import { DeleteOutlined } from '@ant-design/icons';
import { message, Modal } from 'antd';
import { FC } from 'react';
import styled from 'styled-components';
import baseuri from '../../methods/baseuri';

const DeleteSection = styled.div`
	display: inline-flex;
	margin-left: 10px;

	& .deleteIcon {
		font-size: 20px;
		color: red;
		cursor: pointer;
	}
`;
interface IDeleteBanner {
	id: string;
	setRefresh: Function;
}
const DeleteBanner: FC<IDeleteBanner> = ({ id, setRefresh }) => {
	const removeBanner = async () => {
		try {
			const res = await baseuri.delete(`admin/in-app/advert-banner`, {
				params: {
					id,
				},
			});
			if (res.status === 200) {
				message.success('Banner removed Successfully');
				setRefresh(Math.random());
			}
		} catch (e) {
			message.error('Could not complete operation');
		}
	};
	const confirm = () => {
		Modal.confirm({
			title: 'Are you sure you want to Remove this Banner?',
			onOk() {
				removeBanner();
			},
		});
	};
	return (
		<DeleteSection>
			<DeleteOutlined className="deleteIcon" onClick={confirm} />
		</DeleteSection>
	);
};

export default DeleteBanner;
